import * as React from 'react';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import { merge } from 'lodash';
import enTranslation from './en';
/**
 * Wrapper for the i18next library. By default, it uses the translation strings defined in this repository,
 * but the collection of translation strings can be enhanced via the `resources` prop as follows:
 *  <AccurityI18nProvider resources={{
 *    cs: {
 *      key: 'value',
 *      key2: 'value'
 *    }
 *  }}>
 *
 * For debugging purposes, the debug mode can be turned on by passing {debug: true} to 'options' prop
 */
export var AccurityI18nProvider = function (_a) {
    var children = _a.children, _b = _a.resources, resources = _b === void 0 ? {} : _b, _c = _a.options, options = _c === void 0 ? {} : _c;
    var defaultInitOptions = {
        resources: {
            en: { translation: enTranslation },
        },
        lng: 'en',
        fallbackLng: 'en',
        debug: false,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    };
    // overwrite or add options if some options were passed via props
    var initOptions = merge({}, defaultInitOptions, options);
    // overwrite or add translation strings
    initOptions.resources = merge({}, initOptions.resources, resources);
    i18next
        .use(initReactI18next)
        .init(initOptions);
    return (React.createElement(I18nextProvider, { i18n: i18next }, children(i18next)));
};
export default AccurityI18nProvider;
//# sourceMappingURL=AccurityI18nProvider.js.map